import React, { useMemo, useState } from 'react';
import { api } from '../../services/api';

function todayStr() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${dd}`;
}

export default function HRAttendancePage() {
  const [dni, setDni] = useState('');
  const [person, setPerson] = useState(null);
  const [date, setDate] = useState(todayStr());
  const statusOptions = useMemo(() => ['Presente', 'Ausente', 'Vacaciones', 'Permiso', 'Incapacidad'], []);
  const [status, setStatus] = useState('Presente');
  const [notes, setNotes] = useState('');

  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [history, setHistory] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const loadPerson = async () => {
    setLoading(true); setError(''); setMessage('');
    try {
      const res = await api.hr.employees.get({ dni: dni.trim() });
      const data = res?.data || null;
      if (!data) throw new Error('No se encontró la persona por DNI');
      setPerson(data);
    } catch (e) {
      setError(e.message || 'Error al buscar persona');
      setPerson(null);
    } finally {
      setLoading(false);
    }
  };

  const saveAttendance = async () => {
    if (!dni.trim()) { setError('Ingresa un DNI'); return; }
    setLoading(true); setError(''); setMessage('');
    try {
      await api.hr.attendance.upsert({ dni: dni.trim(), date, status, notes });
      setMessage('Asistencia registrada/actualizada');
      // refrescar mini historia del día
      if (person?.person_id) {
        const res = await api.hr.attendance.getDay({ person_id: person.person_id, date });
        const data = res?.data ? [res.data] : [];
        setHistory(data);
      }
    } catch (e) {
      setError(e.message || 'Error al guardar asistencia');
    } finally {
      setLoading(false);
    }
  };

  const loadHistory = async () => {
    if (!person?.person_id) { setError('Busca primero la persona por DNI'); return; }
    const start = from || date;
    const end = to || start;
    setLoading(true); setError(''); setMessage('');
    try {
      const res = await api.hr.attendance.list({ person_id: person.person_id, from: start, to: end });
      setHistory(res?.data || []);
    } catch (e) {
      setError(e.message || 'Error al cargar historial');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '1rem' }}>
      <h2>RRHH · Asistencia</h2>

      {error && <div style={{ color: 'red' }}>{error}</div>}
      {message && <div style={{ color: 'green' }}>{message}</div>}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
        <div>
          <h3>Marcar asistencia</h3>
          <div style={{ display: 'grid', gap: '0.5rem' }}>
            <label>
              DNI
              <input type="text" value={dni} onChange={(e) => setDni(e.target.value)} />
            </label>
            <div>
              <button onClick={loadPerson} disabled={loading}>Buscar persona</button>
            </div>
            {person && (
              <div style={{ border: '1px solid #ddd', padding: '0.5rem' }}>
                <div><strong>Nombre:</strong> {person.name || '—'}</div>
                <div><strong>DNI:</strong> {person.dni || '—'}</div>
                <div><strong>Departamento:</strong> {person.department || '—'}</div>
                <div><strong>Puesto:</strong> {person.position || '—'}</div>
              </div>
            )}
            <label>
              Fecha
              <input type="date" value={date} onChange={(e) => setDate(e.target.value)} />
            </label>
            <label>
              Estado
              <select value={status} onChange={(e) => setStatus(e.target.value)}>
                {statusOptions.map((opt) => (
                  <option key={opt} value={opt}>{opt}</option>
                ))}
              </select>
            </label>
            <label>
              Notas
              <textarea value={notes} onChange={(e) => setNotes(e.target.value)} />
            </label>
            <div>
              <button onClick={saveAttendance} disabled={loading}>Guardar asistencia</button>
            </div>
          </div>
        </div>

        <div>
          <h3>Historial</h3>
          <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.5rem' }}>
            <input type="date" value={from} onChange={(e) => setFrom(e.target.value)} />
            <input type="date" value={to} onChange={(e) => setTo(e.target.value)} />
            <button onClick={loadHistory} disabled={loading}>Cargar</button>
          </div>
          <div style={{ border: '1px solid #ddd' }}>
            <table width="100%">
              <thead>
                <tr>
                  <th style={{ textAlign: 'left' }}>Fecha</th>
                  <th style={{ textAlign: 'left' }}>Estado</th>
                  <th style={{ textAlign: 'left' }}>Notas</th>
                </tr>
              </thead>
              <tbody>
                {history.map((row, idx) => (
                  <tr key={`${row.person_id}-${row.date}-${idx}`}>
                    <td>{row.date}</td>
                    <td>{row.status}</td>
                    <td>{row.notes || ''}</td>
                  </tr>
                ))}
                {history.length === 0 && (
                  <tr><td colSpan={3} style={{ textAlign: 'center' }}>Sin registros</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}